import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormPartnerMarketLeasing } from 'legacy/lut/classes/models/partner360/IFormPartnerMarketLeasing'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IJBPMarketLeasingCrudParams } from '../models'

export const getJBPMarketLeasingCrud = ({
  partnerId,
  programType,
  fYear,
}: IJBPMarketLeasingCrudParams): Crud<IFormPartnerMarketLeasing> => {
  const crud = CrudStore.get(
    CrudStoreItemPartner360.PartnerMarketLeasing
  ) as Crud<IFormPartnerMarketLeasing>

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
      {
        field: 'ProgramType',
        operator: Operator.EQUAL,
        value: programType,
      },
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: fYear,
      },
    ],
  })

  return crud
}
